import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  name() {
    return faker.company.name();
  },

  city() {
    return faker.address.city();
  },

  street() {
    return faker.address.street();
  },

  zipcode() {
    return faker.address.zipCode('#####');
  },

  phone() {
    return faker.phone.number('+49 ## #### ####');
  },

  email() {
    return faker.internet.email(this.name);
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },

  afterCreate(coopPartner, server) {
    let numCoopTypes = faker.datatype.number({
      min: 1,
      max: 2,
    });

    coopPartner.update({
      coopTypes: server.createList('category', numCoopTypes, 'partnerTypeCoop'),
    });
  },
});
